import type { ReactElement } from 'react';

/**
 * Inline SVGs hand-copied from `design/mockups/admin/money-health.html` so the
 * four signals and the four section heads carry the same marks as the mockup.
 * Colour + size come from the parent (currentColor).
 */
const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

/** Warning triangle — holds nothing automatic will move. */
export const EscalatedIcon = (): ReactElement => (
  <svg {...svgProps}>
    <path d="M12 8v5M12 17h.01" />
    <path d="M10.3 3.9L2.6 17.4A2 2 0 004.3 20.4h15.4a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z" />
  </svg>
);

/** Clock — the hold window closing. Deliberately not a warning shape. */
export const ClosingIcon = (): ReactElement => (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

/** Card with a cross — a payout that did not go through. */
export const PayoutFailIcon = (): ReactElement => (
  <svg {...svgProps}>
    <rect x="3" y="6" width="18" height="13" rx="2" />
    <path d="M3 10h18M8 15l4 4M12 15l-4 4" />
  </svg>
);

/** Queued lines with an arrow — webhook rows that never applied. */
export const WebhookIcon = (): ReactElement => (
  <svg {...svgProps}>
    <path d="M4 7h10M4 12h7M4 17h13" />
    <path d="M17 4l4 4-4 4" />
  </svg>
);

/** Info circle — the truncation / scan footnotes. */
export const NoteIcon = (): ReactElement => (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01M11 12h1v4h1" />
  </svg>
);

/** Crossed-out eye — the part of the population the scan never looked at. */
export const BlindSpotIcon = (): ReactElement => (
  <svg {...svgProps}>
    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z" />
    <circle cx="12" cy="12" r="2.5" />
    <path d="M3 21L21 3" />
  </svg>
);

/** Check circle — the all-clear stamp. */
export const AllClearIcon = (): ReactElement => (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8 12.5l2.5 2.5L16 9.5" />
  </svg>
);
